import { render } from "./pageNotFound.vue?vue&type=template&id=232e2578&scoped=true"
import script from "./pageNotFound.vue?vue&type=script&lang=js"
export * from "./pageNotFound.vue?vue&type=script&lang=js"

import "./pageNotFound.vue?vue&type=style&index=0&id=232e2578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232e2578"]])

export default __exports__